export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      bots: [
        {
          botId: 3,
          botUuid: "bots003",
          botName: "アイラ地域サポート向けお知らせbot",
          botUrl: "https://xxxxx.xx.xx",
          botEmail: "mail@xxxxx.com",
          botPassword: "passxxxxx",
          // botNotifyTo: ["aaa@aaa.com", "bbb@bbb.com"],
          service: {
            serviceUuid: "services002",
            serviceName: "〇〇地域サポート"
          }
        },
        {
          botId: 2,
          botUuid: "bots002",
          botName: "アイラ地域サポート向け警戒レベル告知bot",
          botUrl: "https://xxxxx.xx.xx",
          botEmail: "mail@xxxxx.com",
          botPassword: "passxxxxx",
          // botNotifyTo: ["mail.xxxxx.com"],
          service: {
            serviceUuid: "services001",
            serviceName: "アイラ地域サポート"
          }
        },
        {
          botId: 1,
          botUuid: "bots001",
          botName: "アイラ地域サポート向け見守りbot",
          botUrl: "https://xxxxx.xx.xx",
          botEmail: "mail@xxxxx.com",
          botPassword: "passxxxxx",
          // botNotifyTo: ["aaaaaa@cccc.com"],
          service: {
            serviceUuid: "services001",
            serviceName: "アイラ地域サポート"
          }
        }
      ]
    }
  }
}